/* ============================================================
   SCANDALOUS — Wishlist (localStorage, no app required)
   Heart toggle on product cards + header icon + slide-out drawer.
   Fails gracefully: if storage is unavailable, nothing breaks.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'scandalousWishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }
  function itemFromBtn(btn) {
    return {
      handle: btn.getAttribute('data-wishlist-handle'),
      title: btn.getAttribute('data-wishlist-title'),
      url: btn.getAttribute('data-wishlist-url'),
      image: btn.getAttribute('data-wishlist-image'),
      price: btn.getAttribute('data-wishlist-price')
    };
  }

  function updateCount() {
    var c = read().length;
    document.querySelectorAll('.wishlist-count').forEach(function (b) {
      b.textContent = c;
      b.hidden = c === 0;
    });
  }

  function syncHearts() {
    document.querySelectorAll('.js-wishlist-toggle').forEach(function (btn) {
      var active = has(btn.getAttribute('data-wishlist-handle'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function esc(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function renderDrawer() {
    var listEl = document.querySelector('.wishlist-drawer__items');
    var emptyEl = document.querySelector('.wishlist-drawer__empty');
    if (!listEl) return;
    var items = read();
    if (!items.length) {
      listEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    listEl.innerHTML = items.map(function (i) {
      return '<li class="wishlist-drawer__item">' +
        '<a class="wishlist-drawer__thumb" href="' + esc(i.url) + '">' +
          (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="wishlist-drawer__info">' +
          '<a class="wishlist-drawer__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
          '<span class="wishlist-drawer__price">' + esc(i.price) + '</span>' +
        '</div>' +
        '<button type="button" class="wishlist-drawer__remove" data-handle="' + esc(i.handle) + '" aria-label="Remove from wishlist">&times;</button>' +
      '</li>';
    }).join('');
  }

  function openDrawer() {
    renderDrawer();
    document.documentElement.classList.add('wishlist-open');
  }
  function closeDrawer() {
    document.documentElement.classList.remove('wishlist-open');
  }

  function onToggleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.currentTarget;
    var item = itemFromBtn(btn);
    var list = read();
    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === item.handle) { idx = i; break; }
    }
    var added = idx === -1;
    if (added) { list.push(item); } else { list.splice(idx, 1); }
    write(list);
    btn.classList.toggle('is-active', added);
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    btn.classList.remove('wishlist-pop');
    void btn.offsetWidth;
    btn.classList.add('wishlist-pop');
    updateCount();
    renderDrawer();
  }

  function bindToggles(root) {
    (root || document).querySelectorAll('.js-wishlist-toggle').forEach(function (btn) {
      if (btn.dataset.wlBound) return;
      btn.dataset.wlBound = '1';
      btn.addEventListener('click', onToggleClick);
    });
  }

  function init() {
    bindToggles(document);

    document.querySelectorAll('.js-wishlist-open').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    });
    document.querySelectorAll('.js-wishlist-close').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    var listEl = document.querySelector('.wishlist-drawer__items');
    if (listEl) {
      listEl.addEventListener('click', function (e) {
        var rm = e.target.closest('.wishlist-drawer__remove');
        if (!rm) return;
        var h = rm.getAttribute('data-handle');
        write(read().filter(function (i) { return i.handle !== h; }));
        updateCount();
        syncHearts();
        renderDrawer();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    updateCount();
    syncHearts();
    renderDrawer();

    // Re-bind hearts that appear after AJAX (quick view, facet reloads)
    if (window.MutationObserver) {
      new MutationObserver(function () { bindToggles(document); syncHearts(); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
